import {Template} from '@mintdata-wsp/common/state/DataState';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {paths} from '@mintdata-wsp/wsp/ui/routes/Routing';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';
import {Link} from 'react-router-dom';

const styles = require('./TemplatesList.less');
const cx = classnames.bind(styles);

interface Props
{
    template:Template;
    highlightSearchTerm?:boolean;
}

@observer
export class TemplatesListItem extends React.Component<Props, any>
{
    private _getHighlightedTemplateName(name:string):JSX.Element
    {
        const {searchString} = rootState.ui.mainPage;

        const highlightPos = name.toLowerCase().indexOf(searchString.toLowerCase());

        const firstPart = name.substr(0, highlightPos);
        const highlightedPart = name.substr(highlightPos, searchString.length);
        const lastPart = name.substr(highlightPos + searchString.length);
        
        return <span>
            {firstPart}
            <mark className={cx('highlight')}>
                {highlightedPart}
            </mark>
            {lastPart}
        </span>
    }

    @bind
    private _onClickDesignName(event:React.SyntheticEvent<any>)
    {
    }

    @bind
    private _onClickImage(event:React.SyntheticEvent<any>)
    {
        const {template} = this.props;

        controllers.navigation.navigateTo(paths.template(template.templateUrl));
    }

    @bind
    private _onDoubleClickImage(event:React.SyntheticEvent<any>)
    {
    }

    private _renderImage = ():JSX.Element =>
    {
        const {template} = this.props;

        return (
            <div
                className={styles.imgWrapper}
                onClick={this._onClickImage}
            >
                {
                    <picture className={styles.picture}>
                        <source data-srcset={`${template.thumbnailUrlWebP[0]} 1x`} type="image/webp" />
                        <img
                            // src={Images.TransparentGif}
                            src={template.thumbnailUrl[0]}
                            className={cx('lazy', styles.img)}
                            alt={`${template.shortTitle} - ${template.shortDescription}`}
                        />
                    </picture>
                }
            </div>
        );
    };

    render()
    {
        const {template, highlightSearchTerm} = this.props;

        const {shortTitle, shortDescription, templateUrl} = template;

        return (
            <div
                className={styles.design}
            >
                {this._renderImage()}

                <div className={styles.footer}>
                    <div className={styles.content}>
                        <Link
                            to={paths.template(templateUrl)}
                            className={styles.name}
                        >
                            {highlightSearchTerm ? this._getHighlightedTemplateName(shortTitle) : shortTitle}
                        </Link>
                        <div className={styles.time}>
                            {shortDescription}
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}
